import { render, staticRenderFns } from "./VocAdicoesPeriodoIncremental.vue?vue&type=template&id=665047c6&"
import script from "./VocAdicoesPeriodoIncremental.vue?vue&type=script&lang=js&"
export * from "./VocAdicoesPeriodoIncremental.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports